import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const InternalControlsCorporateGovernanceSetup = () => {
  const serviceData = {
    title: "Internal Controls & Corporate Governance Setup",
    heading: "Internal Controls & Corporate Governance Setup",
    image: subTopicImages["Internal Controls & Corporate Governance Setup"],
    intro:
      "Building the systems, discipline and Board oversight expected from listed companies",
    description: [
      "Once listed, a company is required to operate with a significantly higher standard of governance, transparency and process discipline. Investors expect reliable controls, independent oversight and ethical conduct.",
      "We help organisations design and institutionalise governance and control frameworks that meet capital market expectations.",
    ],
    services: [
      {
        title: "This Includes Support With",
        list: [
          "Internal Financial Controls (IFC) design & documentation",
          "establishment of policies, SOPs & process manuals",
          "Board and Committee constitution & governance structure",
          "formalisation of delegation of authority & approval matrix",
          "corporate governance policies (Code of Conduct, Ethics, Insider Trading etc.)",
          "risk assessment and risk management frameworks",
          "compliance monitoring systems",
        ],
        extraInfo:
          "We work collaboratively with the leadership team, ensuring controls are practical, scalable and aligned to real-world operations.",
      },
    ],
    benefitsIntro: "Outcome",
    benefits: [
      "stronger Board oversight",
      "improved investor confidence",
      "reduced risk of financial or compliance lapses",
      "smoother audit & regulatory interactions",
    ],
    research:
      "In simple words — we help transform the company into a listed-ready organisation — internally as well as structurally.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default InternalControlsCorporateGovernanceSetup;
